import type { NormalizedIdeaCardData } from '@/lib/idea-card-types';

const normalizeLabel = (value?: string): string =>
  typeof value === 'string' ? value.trim().toLowerCase() : '';

const shouldPinTopCard = (card: NormalizedIdeaCardData): boolean => {
  if (card.layout !== 'horizontal') {
    return false;
  }

  if (card.preview?.type === 'calendar') {
    return true;
  }

  const normalizedTitle = normalizeLabel(card.title);
  const normalizedGroupLabel = normalizeLabel(card.groupLabel);

  return (
    normalizedTitle === 'post comparison' ||
    normalizedGroupLabel === 'performance analysis' ||
    normalizedGroupLabel === 'post analysis'
  );
};

export const getPinnedTopCardIndices = (cards: NormalizedIdeaCardData[]): number[] =>
  cards.reduce<number[]>((indices, card, index) => {
    if (shouldPinTopCard(card)) {
      indices.push(index);
    }

    return indices;
  }, []);

export const removeHorizontalCardPlaceholders = (content: string, indices: number[]): string => {
  if (!content || indices.length === 0) {
    return content;
  }

  const pinnedPlaceholders = new Set(indices.map((index) => `[HORIZONTAL_CARD:${index}]`));

  return content
    .split('\n')
    .filter((line) => !pinnedPlaceholders.has(line.trim()))
    .join('\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
};
